<template>
  <v-container class="iframe-body modal_content" text-center>
    <v-layout
      v-if="!(loading || confirmed)"
      align-space-around
      wrap
      fill-height
    >
      <v-flex sm7 xs12 class="pr-11">
        <h1 class="modal_content pr-9">
          {{ $t('identity.title') }}
        </h1>

        <p class="select">{{ $t('identity.label') }}</p>
        <v-select
          class="dropdown_menu"
          :items="idAssets"
          v-model="idt"
          solo
          color="#009fb1"
          hide-details
          append-icon="keyboard_arrow_down"
          attach
          :menu-props="{
            contentClass: 'menu-entities',
            maxHeight: 304,
            offsetY: true,
          }"
          :label="$t('identity.placeholder')"
          item-value="id"
          return-object
        >
          <template
            v-slot:selection="{
              item,
            }"
          >
            <div class="d-flex simple-text">
              <v-img
                contain
                width="20"
                :src="require(`@/assets/imgs/ids/${item.name}.png`)"
              >
              </v-img>
              <p class="d-block mb-0 ml-3">
                {{ item.text }} {{ item.username | truncate(8) }}
              </p>
            </div>
          </template>
          <template
            v-slot:item="{
              item,
            }"
          >
            <div class="d-flex simple-text">
              <v-img
                contain
                width="20"
                :src="require(`@/assets/imgs/ids/${item.name}.png`)"
              >
              </v-img>
              <p class="d-block mb-0 ml-3">
                {{ item.text }}
                {{ item.username | truncate(8) }}
              </p>
            </div>
          </template>
        </v-select>
        <p class="simple-text mt-10">
          {{ $t('identity.text') }}
        </p>
      </v-flex>
      <v-flex class="welcome-image d-none d-sm-flex pt-16" sm5>
        <img contain width="348" height="258" src="@/assets/imgs/welcome.png" />
      </v-flex>
    </v-layout>

    <v-row
      v-if="loading && !confirmed"
      style="height: 400px"
      align-content="center"
      justify="center"
      no-gutters
    >
      <v-col v-if="signing && loading" cols="5">
        <p class="select text-center px-4 pt-12 pb-4">
          {{ $t('general.signing') }}
        </p>
      </v-col>
      <v-col cols="12">
        <div class="half-circle-spinner">
          <div class="circle circle-1"></div>
          <div class="circle circle-2"></div>
        </div>
      </v-col>
    </v-row>

    <v-footer fixed class="iframe-footer modal_footer">
      <v-container grid-list-md text-center>
        <v-layout justify-end>
          <div>
            <v-btn
              depressed
              @click="backStep"
              :disabled="signing"
              class="back button-iframe"
              >{{ $t('button.back') }}</v-btn
            >
            <v-btn
              id="begin"
              v-if="noMetamaskStored"
              @click="storeIDS"
              depressed
              class="button-iframe"
              >{{ $t('identity.storeButton') }}</v-btn
            >
            <v-btn
              id="begin"
              v-else-if="noENSStored"
              @click="storeIDS"
              depressed
              class="button-iframe"
              >{{ $t('identity.storeButtonENS') }}</v-btn
            >
            <v-btn
              v-else
              id="submit"
              :disabled="isDisabled || loading"
              depressed
              @click="submitStep"
              class="advance button-iframe"
              >{{ $t('button.sign') }}</v-btn
            >
          </div>
        </v-layout>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import { WEBSITE_URL, ASSET_NAMES } from '@/wallid/const';

// Plugin store methods
import {
  WALLET_LIST,
  WALLID_EXPORT,
  WALLET_SIGN,
} from '@/stores/modules/walletConsts';

import { mapState, mapActions } from 'vuex';

// Main store methods
import { START_TSP, HANDLE_ASSETS } from '@/stores/consts';

const logger = {
  log: require('debug')('iframe:identityView'),
  error: require('debug')('iframe:identityView:error'),
};

export default {
  name: 'Identity',
  watch: {
    idt(value) {
      logger.log('idt watcher: ', value);
    },
  },
  filters: {
    truncate(text = '', length, clamp) {
      clamp = clamp || '...';
      const content = text ? text.toString() : '';
      return content.length > length
        ? content.slice(0, length / 2 + 2) +
            clamp +
            content.slice(content.length - length / 2, content.length)
        : content;
    },
  },
  computed: {
    ...mapState(['idAssets', 'loading', 'confirmed', 'step', 'signing']),
    ...mapState('plugin', {
      hasPlugin: 'hasPlugin',
    }),

    noMetamaskStored() {
      return this.idt?.value === 'MetaMask_NOT_IN_WALLET';
    },

    noENSStored() {
      return this.idt?.value === 'ENS_NOT_IN_WALLET';
    },

    isDisabled() {
      return this.idt == '';
    },
    idt: {
      get() {
        return this.$store.state.idt;
      },
      set(newValue) {
        return this.$store.commit('idt', newValue);
      },
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(newValue) {
        return this.$store.commit('snackbar', newValue);
      },
    },
    errorMsg: {
      get() {
        return this.$store.state.errorMsg;
      },
      set(newValue) {
        return this.$store.commit('errorMsg', newValue);
      },
    },
    authToken: {
      get() {
        return this.$store.state.authToken;
      },
      set(newValue) {
        return this.$store.commit('authToken', newValue);
      },
    },
  },
  created() {
    logger.log('this.idAssets:', this.idAssets);
    if (this.idAssets.length > 0) {
      this.$store.commit('idt', this.idAssets[0]);
    }
  },
  methods: {
    ...mapActions('plugin', {
      getListAssets: WALLET_LIST,
      getWalletAsset: WALLID_EXPORT,
      getWalletSignature: WALLET_SIGN,
    }),

    ...mapActions({
      handleAssets: HANDLE_ASSETS,
    }),

    getParentOrigin() {
      const locationAreDisctint = window.location !== window.parent.location;
      const parentOrigin = (
        (locationAreDisctint ? document.referrer : document.location) || ''
      ).toString();
      if (parentOrigin) {
        return new URL(parentOrigin).origin;
      }

      const currentLocation = document.location;

      if (currentLocation.ancestorOrigins?.length) {
        return currentLocation.ancestorOrigins[0];
      }

      return '';
    },
    storeIDS() {
      var currentUrl = this.getParentOrigin();
      let event = {
        METAMASK: 'Store Metamask in MyWalliD',
        ENS: 'Store an ENS domain',
      };

      this.$gtag.event(event[this.idt?.name?.toUpperCase?.()], {
        event_category: 'ETH',
        event_label: 'welcome screen',
      });
      let wallidURL =
        WEBSITE_URL +
        `?flow=WEB3_${this.idt?.name?.toUpperCase?.()}&returnURL=${encodeURIComponent(
          currentUrl
        )}&gtag=${window.GA_ID}`;

      logger.log('wallidURL: ', wallidURL);
      // let downloadUrl =
      //   'https://chrome.google.com/webstore/detail/wallid-wallet/eknlkogikcabnjbjnhmjllabckeapdii?hl=pt-PT';
      window.open(wallidURL, '_blank');

      if (this.hasPlugin) {
        window.onfocus = this.onFocusCheckIDS;
      }
    },
    onFocusCheckIDS() {
      // to avoid popup spam on focus change, we check only once
      window.onfocus = null;
      this.getListAssets()
        .then((assets) => {
          this.handleAssets(assets)
            .then((lastIndex) => {
              this.$store.commit('idt', this.idAssets[lastIndex]);
              this.$store.commit('loading', false);
            })
            .catch((e) => {
              logger.log(('handleAssets:', e));
            });
        })
        .catch((e) => {
          logger.log('onFocusCheckIDS error:', e);
          if (e === 'REJECTED') {
            window.onfocus = null;
          }
        });

      // this.errorMsgStatus = 'noIdentitiesTimed';
    },
    backStep() {
      this.$store.commit('decStep');
      this.snackbar = false;
      this.errorMsg = '';
      this.errorMsgStatus = '';
      // this.$store.commit('idAssets', []);
      this.$router.push({ name: 'Home' });
      this.$store.commit('loading', false);
      this.$store.commit('terms', false);
    },
    async getAssetInfo() {
      this.errorMsg = '';

      // Possible error messages to show
      // TSP failed to find the selected identity in this wallet address.

      // TSP failed to get your identity due to session expiration.

      // TSP failed to get your identity.

      try {
        // New code to use wallet address for signature 12/2021
        if (this.idt) {
          // TODO: implement backend authentication
          // this.authToken = await this.$store.dispatch(GET_TOKEN_WALLET);
          // logger.debug('authToken: ', this.authToken);

          // let verifyIDToken = await this.$store.dispatch(
          //   VERIFY_WALLET,
          //   this.authToken
          // );

          // logger.debug('verifyIDToken: ', verifyIDToken);
          // if (!verifyIDToken) {
          //   throw { code: 400, message: 'Error Verify' };
          // }
          let asset;
          // to use MyWalliD we ony need the wallet address
          if (this.idt.name === ASSET_NAMES.MYWALLID) {
            asset = {
              assetName: this.idt.name,
              username: this.idt.value,
              profileData: { username: this.idt.value },
            };
          } else {
            asset = await this.getWalletAsset({
              type: this.idt.controller,
              idt: this.idt.id,
            });
          }

          const dataToSign = this.$t('signatureMessage', {
            envelopeId: window.ENVELOPE_ID,
            assetName: asset.assetName || asset.socialName,
            username: asset.username,
          });

          const waSignature = await this.getWalletSignature({
            dataToSign,
          });
          this.$store.commit('loading', true);
          this.$store.commit('signing', true);

          logger.log('-- CALL SIGN API--', START_TSP, asset, waSignature);

          var res = await this.$store.dispatch(START_TSP, {
            asset,
            waSignature,
          });
          logger.log('Data sent to TSP response : ', res);
          logger.log('Document signed');
          this.$store.commit('redirectUrl', res.data?.redirectionURL);
          this.$store.commit('envelopeID', res.data?.envelopeID);
          this.$store.commit('documents', res.data?.documents);

          this.$store.commit('signing', false);

          this.$router.push('success');

          this.$store.commit('step', 3);

          return res;
        }
      } catch (errorMsg) {
        this.snackbar = true;

        if (errorMsg !== 'REJECTED') {
          const {
            event,
            event_category,
            event_label,
            message,
            type,
          } = errorMsg;

          if (type == 'banner') {
            this.$store.commit('errorMsg', message);
          } else {
            this.errorMsg[type] = message;
          }

          this.$gtag.event(event, {
            event_category,
            event_label,
          });
        }
      } finally {
        // this.$store.commit('step', 1);
        this.$store.commit('loading', false);
        this.$store.commit('confirm', false);
        this.$store.commit('signing', false);
      }
    },
    submitStep: async function() {
      // this.$store.commit('confirm', true);
      this.$gtag.event('Sign document', {
        event_category: 'ETH',
        event_label: 'Signing screen',
      });
      this.getAssetInfo();
    },
  },
  data() {
    return {
      rules: { required: (value) => !!value || 'Please select one option.' },
      errorMM: false,
    };
  },
};
</script>

<style lang="scss">
.menu-entities {
  // padding-left: 12px;
  // padding-right: 2px;
  margin-top: -6px;
  margin-left: -1px;
  min-width: 450px !important;
  border: solid 1px #01a3b0;
  border-top: none;

  border-radius: 0;
  .v-select-list {
    max-width: 850px;
    // border: solid 1px #01a3b0;
    // border-top: none;
    .v-list-item {
      min-height: 40px;
      color: #009fb1 !important;
    }
    .simple-text {
      font-family: 'Montserrat';
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: normal;
      color: var(--charcoal-grey);
    }
  }
}
.dropdown_menu {
  max-width: 450px;
  .v-input__slot {
    padding-left: 16px !important;
  }
  .v-input__control {
    min-height: 42px !important;
  }

  &.v-select--is-menu-active .v-input__control {
    border: solid 1px #01a3b0;
    border-bottom-color: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .v-select__selection {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #035b60;
  }

  > .v-input__control:hover {
    border-radius: 2px;
    border: solid 1px #01a3b0;
  }
  &:hover {
    .v-icon.theme--light {
      color: #009fb1 !important;
    }
  }
  &.v-select--is-menu-active .v-input__control:hover {
    border-bottom-color: transparent;
  }

  .v-input__control {
    border-radius: 2px;
    border: solid 1px #b8b9bb;
  }
}
</style>

<style lang="scss">
.v-messages__message {
  color: #d0021b;
}
a {
  color: #01a3b0;
}

.Please-wait {
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #035b60;
  margin-top: 106px;
}

.select {
  margin-top: 24px;
  font-family: 'Montserrat';
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: var(--charcoal-grey);
}
.Step-1 {
  padding-top: 0;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: 'Montserrat';
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: var(--charcoal-grey);
  text-align: left;
}

.half-circle-spinner,
.half-circle-spinner * {
  box-sizing: border-box;
}

.half-circle-spinner {
  width: 45px;
  height: 45px;
  border-radius: 100%;
  position: relative;
  margin: auto;
}

.half-circle-spinner .circle {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(30px / 10) solid transparent;
}

.half-circle-spinner .circle.circle-1 {
  border-top-color: #01a3b0;
  animation: half-circle-spinner-animation 2s infinite;
}

.half-circle-spinner .circle.circle-2 {
  border-bottom-color: #035b60;
  animation: half-circle-spinner-animation 2s infinite alternate;
}

@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
